const modulacoes = [
  {
    titulo: 'Total',
    descricao: 'Vidros que vão do piso ao teto, maximizando a luminosidade e a amplitude visual do ambiente.',
    image: 'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/modelos/modulacoes-total.jpg',
    alt: 'Modulação total de vidro piso-teto em divisória corporativa — Gabbinetto',
  },
  {
    titulo: 'Grande',
    descricao: 'Painéis de vidro amplos que proporcionam excelente passagem de luz com estrutura elegante.',
    image: 'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/modelos/modulacoes-grandes.jpg',
    alt: 'Modulação grande de vidro piso-teto em divisória corporativa — Gabbinetto',
  },
  {
    titulo: 'Média',
    descricao: 'Composição intermediária que equilibra área de vidro com perfis estruturais.',
    image: 'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/modelos/modulacoes-medias.jpg',
    alt: 'Modulação média de vidro piso-teto em divisória corporativa — Gabbinetto',
  },
  {
    titulo: 'Pequena',
    descricao: 'Módulos menores que criam um padrão de quadrícula mais denso e arquitetônico.',
    image: 'https://www.gabbinetto.com.br/img/produtos/divisoria-piso-teto-vidro-duplo/modelos/modulacoes-pequenas.jpg',
    alt: 'Modulação pequena de vidro piso-teto em divisória corporativa — Gabbinetto',
  },
];

export default function ModulacoesSection() {
  return (
    <section className="bg-background-50">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Modulações de vidro
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight mb-5">
            Personalize a composição de vidro do seu projeto.
          </h2>
          <p className="text-foreground-500 text-[15px] md:text-[16px] leading-relaxed">
            Escolha entre uma variedade de tamanhos de vidros para criar espaços elegantes e funcionais,
            conforme o projeto arquitetônico de cada ambiente.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {modulacoes.map((m) => (
            <div
              key={m.titulo}
              className="group bg-white rounded-2xl border border-background-200/60 overflow-hidden flex flex-col"
            >
              <div className="img-zoom overflow-hidden bg-background-100 aspect-[9/16]">
                <img
                  src={m.image}
                  alt={m.alt}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-contain object-center"
                />
              </div>
              <div className="p-6 text-center">
                <h3 className="text-foreground-950 font-semibold text-[16px] mb-2">
                  {m.titulo}
                </h3>
                <p className="text-foreground-500 text-[13px] leading-relaxed font-light">
                  {m.descricao}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}